///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const PendingBidsIcon = ({
  height,
  fill,
  title = messages.pendingBids.defaultMessage,
  width
}) => (
  <svg
    aria-labelledby="pending-bids-icon"
    height={height}
    viewBox="0 0 17 18"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id="pending-bids-icon">{title}</title>
    <path
      fill={fill}
      d="M10.917 8a3.734 3.734 0 013.75 3.75c0 .733-.209 1.425-.575 2l2.566 2.583-1.158 1.159-2.6-2.559a3.748 3.748 0 01-1.983.567 3.734 3.734 0 01-3.75-3.75A3.734 3.734 0 0110.917 8m0 1.667a2.083 2.083 0 100 4.166 2.083 2.083 0 000-4.166M2.167.5h11.666A1.66 1.66 0 0115.5 2.167v6.691a5.656 5.656 0 00-1.667-1.691v-5H2.167v11.666h3.75A5.448 5.448 0 007.008 15.5H2.167A1.66 1.66 0 01.5 13.833V2.167A1.66 1.66 0 012.167.5m1.666 3.333h8.334V5.5H3.833V3.833m0 3.334h4.192a5.656 5.656 0 00-1.692 1.666h-2.5V7.167m0 3.333h1.809a5.808 5.808 0 00-.142 1.25v.417H3.833V10.5z"
    />
  </svg>
);

export default PendingBidsIcon;
